import { render, staticRenderFns } from "./imageFilterRange.vue?vue&type=template&id=2b8545f3&scoped=true&"
import script from "./imageFilterRange.vue?vue&type=script&lang=js&"
export * from "./imageFilterRange.vue?vue&type=script&lang=js&"
import style0 from "./imageFilterRange.vue?vue&type=style&index=0&id=2b8545f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8545f3",
  null
  
)

export default component.exports